// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-card {
  display: flex;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  gap: 30px;
}

.profile-left {
  width: 430px;
  text-align: center;
  border-right: 1px solid #eee;
  padding-right: 20px;
}

.profile-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 10px;
}

.emp-role {
  color: #777;
  font-size: 14px;
}

.profile-right {
  flex: 1 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.profile-row {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.profile-extra {
  margin-top: 20px;
  display: flex;
  gap: 20px;
}

.info-card {
  flex: 1 1;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
}

.status-active {
  color: green;
  font-weight: bold;
}
.profile-row span:first-child {
  font-weight: 600;
  color: #444;
}
/* SEARCH WRAPPER */
.search-container {
  display: flex;
  justify-content: flex-start;   /* ⬅ move left */
  align-items: center;
  margin-top: 15px;
  margin-left: -10px;            /* ⬅ subtle left shift */
}

/* SEARCH INPUT */
.search-input {
  width: 280px;
  height: 42px;
  padding: 0 18px;
  border-radius: 25px;
  border: 1px solid #ddd;
  outline: none;
  font-size: 14px;
  background: #fff;
  transition: all 0.25s ease;
}

/* FOCUS EFFECT */
.search-input:focus {
  border-color: #1e5ad7;
  box-shadow: 0 0 0 3px rgba(30, 90, 215, 0.12);
}
@media (max-width: 768px) {
  .search-input {
    width: 100%;
  }

  .search-container {
    margin-left: 0;
  }
}
/* HEADER AREA */
.profile-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.emp-name {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #222;
}

.emp-badge {
  background: #e8f0ff;
  color: #1e5ad7;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
}

/* INFO GRID */
.profile-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 15px;
}

/* INFO CARD */
.info-item {
  background: #f9fafb;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item .label {
  font-size: 12px;
  color: #777;
  font-weight: 500;
}

.info-item .value {
  font-size: 15px;
  color: #111;
  font-weight: 600;
}
.profile-card {
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 30px;
}

/* RIGHT PANEL */
.profile-right-panel {
  padding-left: 30px;
  border-left: 1px solid #eee;
}

/* SECTION TITLE */
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #555;
  margin-bottom: 15px;
}

/* STATS */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 25px;
}

.stat-box {
  background: #f9fafb;
  padding: 16px;
  border-radius: 12px;
  text-align: center;
}

.stat-box span {
  font-size: 12px;
  color: #777;
}

.stat-box strong {
  display: block;
  font-size: 22px;
  font-weight: 700;
  margin-top: 5px;
}

/* ACTION BUTTONS */
.quick-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.action-btn {
  border: none;
 background: #e74c3c;
  color: #fff;
  padding: 12px;
  border-radius: 10px;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s ease;
}

.action-btn:hover {
  background: #e74c3c;
}

.action-btn.secondary {
  background: #e9eefc;
  color: #1e5ad7;
}

.action-btn.secondary:hover {
  background: #dbe4ff;
}

/* MOBILE */
@media (max-width: 992px) {
  .profile-card {
    grid-template-columns: 1fr;
  }

  .profile-right-panel {
    border-left: none;
    padding-left: 0;
    margin-top: 20px;
  }
}

/* =========================================================
   EMPLOYEE PROFILE - RESPONSIVE
   ========================================================= */

/* Main dashboard */
.dashboard-wrapper {
    display: flex;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
}

/* Sidebar */
.sidebar-container {
    width: 250px;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1001;
    transition: transform 0.3s ease;
}

.sidebar-container.closed {
    transform: translateX(-250px);
}

/* Page area */
.page-area {
    margin-left: 250px;
    width: calc(100% - 250px);
    min-width: 0;
    transition: all 0.3s ease;
}

.page-area.full {
    margin-left: 0;
    width: 100%;
}

/* Main content */
.main-content {
    width: 100%;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 80px 30px 30px 30px;

    background: linear-gradient(
        135deg,
        #f8eaea 0%,
        #f4f8fc 55%
    );
}

/* Container */
.main-content .container-fluid {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}


/* =========================================================
   DASHBOARD TITLE
   ========================================================= */

.dashboard-title {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 20px;
    font-weight: 700;
    color: #222;
    margin-bottom: 18px;
}

.dashboard-icon {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
}


/* =========================================================
   SEARCH HEADER
   ========================================================= */

.search-card {
    width: 100%;
    box-sizing: border-box;

    background: #fff;
    border-radius: 30px;
    padding: 20px 30px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 20px;
    margin-bottom: 25px;

    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.06);
}

.search-card h2 {
    margin: 0;
    font-size: 24px;
    color: #222;
    white-space: nowrap;
}

/* Search wrapper */
.search-card > div {
    position: relative;
    width: 420px;
    max-width: 100%;
}

/* Search input */
.search-card .search-input {
    width: 100%;
    height: 44px;
    box-sizing: border-box;

    border-radius: 25px;
    border: 1px solid #ddd;

    padding: 0 45px 0 18px;

    outline: none;
    font-size: 14px;
    background: #fff;
}

.search-card .search-input:focus {
    border-color: #e74c3c;
    box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.10);
}


/* =========================================================
   TABLE WRAPPER
   ========================================================= */

.table-responsive {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    background: #fff;
    border-radius: 20px;

    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.06);

    -webkit-overflow-scrolling: touch;
}

/* Employee table */
.table-responsive .project-table {
    width: 100%;
    min-width: 900px;

    border-collapse: separate;
    border-spacing: 0 8px;

    margin: 0;
}

/* Header */
.project-table thead th {
    background: #eef3fb;
    padding: 14px;
    font-size: 14px;
    font-weight: 600;

    white-space: nowrap;
    text-align: left;
}

/* Body */
.project-table tbody tr {
    background: #fff;
}

.project-table tbody td {
    padding: 14px;
    font-size: 14px;
    vertical-align: middle;
}

/* Profile image */
.project-table tbody td img {
    display: block;
}


/* =========================================================
   PAGINATION
   ========================================================= */

.pagination-section {
    width: 100%;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 15px;

    margin-top: 20px;
    margin-bottom: 20px;
}

.pagination-section p {
    margin: 0;
    font-size: 14px;
    color: #333;
}

/* Pagination buttons */
.pagination-controls {
    display: flex;
    align-items: center;
    gap: 5px;
}

.pagination-controls button {
    min-width: 45px;
    height: 42px;

    padding: 0 12px;

    border: 1px solid #ddd;
    background: #fff;

    border-radius: 8px;

    font-size: 18px;
    font-weight: 600;

    cursor: pointer;

    transition: all 0.2s ease;
}

.pagination-controls button:hover:not(:disabled) {
    background: #fceaea;
    border-color: #e74c3c;
    color: #e74c3c;
}

.pagination-controls button.active {
    background: #e74c3c;
    color: #fff;
    border-color: #e74c3c;
}

.pagination-controls button:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}


/* =========================================================
   TABLET
   ========================================================= */

@media (max-width: 992px) {

    .page-area {
        margin-left: 0;
        width: 100%;
    }

    .main-content {
        padding-left: 20px;
        padding-right: 20px;
    }

    .search-card {
        padding: 18px 20px;
    }

    .search-card h2 {
        font-size: 21px;
    }

    .search-card > div {
        width: 320px;
    }
}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 768px) {

    /* -----------------------------------------
       SIDEBAR
       ----------------------------------------- */

    .sidebar-container {
        width: 250px;
        height: 100vh;
        position: fixed;

        left: 0;
        top: 0;

        z-index: 2000;
    }

    .sidebar-container.closed {
        transform: translateX(-250px);
    }

    /* -----------------------------------------
       PAGE
       ----------------------------------------- */

    .page-area,
    .page-area.full {
        width: 100%;
        margin-left: 0;
    }

    .main-content {
        width: 100%;
        min-height: 100vh;

        padding: 75px 12px 25px 12px;

        box-sizing: border-box;
        overflow-x: hidden;
    }

    .main-content .container-fluid {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    /* -----------------------------------------
       DASHBOARD TITLE
       ----------------------------------------- */

    .dashboard-title {
        font-size: 18px;
        margin-bottom: 15px;
    }

    .dashboard-icon {
        width: 24px;
        height: 24px;
    }


    /* -----------------------------------------
       SEARCH CARD
       ----------------------------------------- */

    .search-card {
        width: 100%;

        padding: 18px 15px;

        border-radius: 20px;

        display: flex;
        flex-direction: column;

        align-items: stretch;
        justify-content: flex-start;

        gap: 15px;
    }

    .search-card h2 {
        font-size: 20px;
        text-align: left;

        white-space: normal;
        margin: 0;
    }

    .search-card > div {
        width: 100%;
        max-width: 100%;
    }

    .search-card .search-input {
        width: 100%;
        height: 44px;
        box-sizing: border-box;
    }


    /* -----------------------------------------
       TABLE
       ----------------------------------------- */

    .table-responsive {
        width: 100%;

        overflow-x: auto;
        overflow-y: hidden;

        border-radius: 15px;

        -webkit-overflow-scrolling: touch;
    }

    .table-responsive .project-table {
        min-width: 900px;
        width: 900px;
    }

    .project-table thead th {
        padding: 12px;
        font-size: 13px;
    }

    .project-table tbody td {
        padding: 12px;
        font-size: 13px;
    }


    /* -----------------------------------------
       PAGINATION
       ----------------------------------------- */

    .pagination-section {
        width: 100%;

        display: flex;
        flex-direction: column;

        align-items: center;
        justify-content: center;

        gap: 12px;

        margin-top: 18px;
    }

    .pagination-section p {
        width: 100%;
        text-align: center;
        font-size: 13px;
    }

    .pagination-controls {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
    }

    .pagination-controls button {
        min-width: 40px;
        height: 40px;

        padding: 0 9px;

        font-size: 17px;
        border-radius: 8px;
    }
}


/* =========================================================
   SMALL MOBILE
   ========================================================= */

@media (max-width: 480px) {

    .main-content {
        padding: 70px 8px 20px 8px;
    }

    .dashboard-title {
        font-size: 17px;
    }

    .search-card {
        padding: 15px 12px;
        border-radius: 18px;
    }

    .search-card h2 {
        font-size: 18px;
    }

    .search-card .search-input {
        height: 42px;
        font-size: 13px;
    }

    .table-responsive {
        border-radius: 12px;
    }

    .pagination-controls {
        gap: 4px;
    }

    .pagination-controls button {
        min-width: 36px;
        height: 38px;
        padding: 0 7px;
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/EmployeeProfile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,2BAA2B,IAAI,gBAAgB;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB,aAAa,wBAAwB;AACzD;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;AACA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;CACb,mBAAmB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;8DAE8D;;AAE9D,mBAAmB;AACnB;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,YAAY;AACZ;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,4BAA4B;;IAE5B;;;;KAIC;AACL;;AAEA,cAAc;AACd;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;;AAGA;;8DAE8D;;AAE9D;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;;IAEtB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,SAAS;IACT,mBAAmB;;IAEnB,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;;IAEtB,mBAAmB;IACnB,sBAAsB;;IAEtB,sBAAsB;;IAEtB,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;;IAElB,gBAAgB;IAChB,mBAAmB;;IAEnB,2CAA2C;;IAE3C,iCAAiC;AACrC;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,gBAAgB;;IAEhB,yBAAyB;IACzB,qBAAqB;;IAErB,SAAS;AACb;;AAEA,WAAW;AACX;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,SAAS;AACT;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,cAAc;AAClB;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;;IAEtB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,SAAS;;IAET,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;;IAEZ,eAAe;;IAEf,sBAAsB;IACtB,gBAAgB;;IAEhB,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;;IAEhB,eAAe;;IAEf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;;AAGA;;8DAE8D;;AAE9D;;IAEI;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ;;;AAGA;;8DAE8D;;AAE9D;;IAEI;;kDAE8C;;IAE9C;QACI,YAAY;QACZ,aAAa;QACb,eAAe;;QAEf,OAAO;QACP,MAAM;;QAEN,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;;kDAE8C;;IAE9C;;QAEI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,iBAAiB;;QAEjB,4BAA4B;;QAE5B,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;;kDAE8C;;IAE9C;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;;IAGA;;kDAE8C;;IAE9C;QACI,WAAW;;QAEX,kBAAkB;;QAElB,mBAAmB;;QAEnB,aAAa;QACb,sBAAsB;;QAEtB,oBAAoB;QACpB,2BAA2B;;QAE3B,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;;QAEhB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;IAC1B;;;IAGA;;kDAE8C;;IAE9C;QACI,WAAW;;QAEX,gBAAgB;QAChB,kBAAkB;;QAElB,mBAAmB;;QAEnB,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;;IAGA;;kDAE8C;;IAE9C;QACI,WAAW;;QAEX,aAAa;QACb,sBAAsB;;QAEtB,mBAAmB;QACnB,uBAAuB;;QAEvB,SAAS;;QAET,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,YAAY;;QAEZ,cAAc;;QAEd,eAAe;QACf,kBAAkB;IACtB;AACJ;;;AAGA;;8DAE8D;;AAE9D;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,cAAc;QACd,eAAe;IACnB;AACJ","sourcesContent":[".profile-card {\r\n  display: flex;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 15px rgba(0,0,0,0.08);\r\n  gap: 30px;\r\n}\r\n\r\n.profile-left {\r\n  width: 430px;\r\n  text-align: center;\r\n  border-right: 1px solid #eee;\r\n  padding-right: 20px;\r\n}\r\n\r\n.profile-avatar {\r\n  width: 120px;\r\n  height: 120px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.emp-role {\r\n  color: #777;\r\n  font-size: 14px;\r\n}\r\n\r\n.profile-right {\r\n  flex: 1;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 15px;\r\n}\r\n\r\n.profile-row {\r\n  background: #f8f9fa;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 14px;\r\n}\r\n\r\n.profile-extra {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\n.info-card {\r\n  flex: 1;\r\n  background: #fff;\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n  box-shadow: 0 3px 10px rgba(0,0,0,0.05);\r\n}\r\n\r\n.status-active {\r\n  color: green;\r\n  font-weight: bold;\r\n}\r\n.profile-row span:first-child {\r\n  font-weight: 600;\r\n  color: #444;\r\n}\r\n/* SEARCH WRAPPER */\r\n.search-container {\r\n  display: flex;\r\n  justify-content: flex-start;   /* ⬅ move left */\r\n  align-items: center;\r\n  margin-top: 15px;\r\n  margin-left: -10px;            /* ⬅ subtle left shift */\r\n}\r\n\r\n/* SEARCH INPUT */\r\n.search-input {\r\n  width: 280px;\r\n  height: 42px;\r\n  padding: 0 18px;\r\n  border-radius: 25px;\r\n  border: 1px solid #ddd;\r\n  outline: none;\r\n  font-size: 14px;\r\n  background: #fff;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n/* FOCUS EFFECT */\r\n.search-input:focus {\r\n  border-color: #1e5ad7;\r\n  box-shadow: 0 0 0 3px rgba(30, 90, 215, 0.12);\r\n}\r\n@media (max-width: 768px) {\r\n  .search-input {\r\n    width: 100%;\r\n  }\r\n\r\n  .search-container {\r\n    margin-left: 0;\r\n  }\r\n}\r\n/* HEADER AREA */\r\n.profile-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.emp-name {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #222;\r\n}\r\n\r\n.emp-badge {\r\n  background: #e8f0ff;\r\n  color: #1e5ad7;\r\n  font-size: 12px;\r\n  padding: 4px 10px;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* INFO GRID */\r\n.profile-info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 15px;\r\n}\r\n\r\n/* INFO CARD */\r\n.info-item {\r\n  background: #f9fafb;\r\n  border-radius: 10px;\r\n  padding: 14px 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.info-item .label {\r\n  font-size: 12px;\r\n  color: #777;\r\n  font-weight: 500;\r\n}\r\n\r\n.info-item .value {\r\n  font-size: 15px;\r\n  color: #111;\r\n  font-weight: 600;\r\n}\r\n.profile-card {\r\n  display: grid;\r\n  grid-template-columns: 420px 1fr;\r\n  gap: 30px;\r\n}\r\n\r\n/* RIGHT PANEL */\r\n.profile-right-panel {\r\n  padding-left: 30px;\r\n  border-left: 1px solid #eee;\r\n}\r\n\r\n/* SECTION TITLE */\r\n.section-title {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #555;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n/* STATS */\r\n.stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 15px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.stat-box {\r\n  background: #f9fafb;\r\n  padding: 16px;\r\n  border-radius: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.stat-box span {\r\n  font-size: 12px;\r\n  color: #777;\r\n}\r\n\r\n.stat-box strong {\r\n  display: block;\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  margin-top: 5px;\r\n}\r\n\r\n/* ACTION BUTTONS */\r\n.quick-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.action-btn {\r\n  border: none;\r\n background: #e74c3c;\r\n  color: #fff;\r\n  padding: 12px;\r\n  border-radius: 10px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: 0.2s ease;\r\n}\r\n\r\n.action-btn:hover {\r\n  background: #e74c3c;\r\n}\r\n\r\n.action-btn.secondary {\r\n  background: #e9eefc;\r\n  color: #1e5ad7;\r\n}\r\n\r\n.action-btn.secondary:hover {\r\n  background: #dbe4ff;\r\n}\r\n\r\n/* MOBILE */\r\n@media (max-width: 992px) {\r\n  .profile-card {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .profile-right-panel {\r\n    border-left: none;\r\n    padding-left: 0;\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n/* =========================================================\r\n   EMPLOYEE PROFILE - RESPONSIVE\r\n   ========================================================= */\r\n\r\n/* Main dashboard */\r\n.dashboard-wrapper {\r\n    display: flex;\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    overflow-x: hidden;\r\n}\r\n\r\n/* Sidebar */\r\n.sidebar-container {\r\n    width: 250px;\r\n    height: 100vh;\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    z-index: 1001;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.sidebar-container.closed {\r\n    transform: translateX(-250px);\r\n}\r\n\r\n/* Page area */\r\n.page-area {\r\n    margin-left: 250px;\r\n    width: calc(100% - 250px);\r\n    min-width: 0;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.page-area.full {\r\n    margin-left: 0;\r\n    width: 100%;\r\n}\r\n\r\n/* Main content */\r\n.main-content {\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    box-sizing: border-box;\r\n    padding: 80px 30px 30px 30px;\r\n\r\n    background: linear-gradient(\r\n        135deg,\r\n        #f8eaea 0%,\r\n        #f4f8fc 55%\r\n    );\r\n}\r\n\r\n/* Container */\r\n.main-content .container-fluid {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   DASHBOARD TITLE\r\n   ========================================================= */\r\n\r\n.dashboard-title {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    color: #222;\r\n    margin-bottom: 18px;\r\n}\r\n\r\n.dashboard-icon {\r\n    width: 28px;\r\n    height: 28px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   SEARCH HEADER\r\n   ========================================================= */\r\n\r\n.search-card {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    background: #fff;\r\n    border-radius: 30px;\r\n    padding: 20px 30px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    gap: 20px;\r\n    margin-bottom: 25px;\r\n\r\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.search-card h2 {\r\n    margin: 0;\r\n    font-size: 24px;\r\n    color: #222;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* Search wrapper */\r\n.search-card > div {\r\n    position: relative;\r\n    width: 420px;\r\n    max-width: 100%;\r\n}\r\n\r\n/* Search input */\r\n.search-card .search-input {\r\n    width: 100%;\r\n    height: 44px;\r\n    box-sizing: border-box;\r\n\r\n    border-radius: 25px;\r\n    border: 1px solid #ddd;\r\n\r\n    padding: 0 45px 0 18px;\r\n\r\n    outline: none;\r\n    font-size: 14px;\r\n    background: #fff;\r\n}\r\n\r\n.search-card .search-input:focus {\r\n    border-color: #e74c3c;\r\n    box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.10);\r\n}\r\n\r\n\r\n/* =========================================================\r\n   TABLE WRAPPER\r\n   ========================================================= */\r\n\r\n.table-responsive {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n\r\n    background: #fff;\r\n    border-radius: 20px;\r\n\r\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.06);\r\n\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n/* Employee table */\r\n.table-responsive .project-table {\r\n    width: 100%;\r\n    min-width: 900px;\r\n\r\n    border-collapse: separate;\r\n    border-spacing: 0 8px;\r\n\r\n    margin: 0;\r\n}\r\n\r\n/* Header */\r\n.project-table thead th {\r\n    background: #eef3fb;\r\n    padding: 14px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n\r\n    white-space: nowrap;\r\n    text-align: left;\r\n}\r\n\r\n/* Body */\r\n.project-table tbody tr {\r\n    background: #fff;\r\n}\r\n\r\n.project-table tbody td {\r\n    padding: 14px;\r\n    font-size: 14px;\r\n    vertical-align: middle;\r\n}\r\n\r\n/* Profile image */\r\n.project-table tbody td img {\r\n    display: block;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   PAGINATION\r\n   ========================================================= */\r\n\r\n.pagination-section {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    gap: 15px;\r\n\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.pagination-section p {\r\n    margin: 0;\r\n    font-size: 14px;\r\n    color: #333;\r\n}\r\n\r\n/* Pagination buttons */\r\n.pagination-controls {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n}\r\n\r\n.pagination-controls button {\r\n    min-width: 45px;\r\n    height: 42px;\r\n\r\n    padding: 0 12px;\r\n\r\n    border: 1px solid #ddd;\r\n    background: #fff;\r\n\r\n    border-radius: 8px;\r\n\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n\r\n    cursor: pointer;\r\n\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.pagination-controls button:hover:not(:disabled) {\r\n    background: #fceaea;\r\n    border-color: #e74c3c;\r\n    color: #e74c3c;\r\n}\r\n\r\n.pagination-controls button.active {\r\n    background: #e74c3c;\r\n    color: #fff;\r\n    border-color: #e74c3c;\r\n}\r\n\r\n.pagination-controls button:disabled {\r\n    opacity: 0.45;\r\n    cursor: not-allowed;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   TABLET\r\n   ========================================================= */\r\n\r\n@media (max-width: 992px) {\r\n\r\n    .page-area {\r\n        margin-left: 0;\r\n        width: 100%;\r\n    }\r\n\r\n    .main-content {\r\n        padding-left: 20px;\r\n        padding-right: 20px;\r\n    }\r\n\r\n    .search-card {\r\n        padding: 18px 20px;\r\n    }\r\n\r\n    .search-card h2 {\r\n        font-size: 21px;\r\n    }\r\n\r\n    .search-card > div {\r\n        width: 320px;\r\n    }\r\n}\r\n\r\n\r\n/* =========================================================\r\n   MOBILE\r\n   ========================================================= */\r\n\r\n@media (max-width: 768px) {\r\n\r\n    /* -----------------------------------------\r\n       SIDEBAR\r\n       ----------------------------------------- */\r\n\r\n    .sidebar-container {\r\n        width: 250px;\r\n        height: 100vh;\r\n        position: fixed;\r\n\r\n        left: 0;\r\n        top: 0;\r\n\r\n        z-index: 2000;\r\n    }\r\n\r\n    .sidebar-container.closed {\r\n        transform: translateX(-250px);\r\n    }\r\n\r\n    /* -----------------------------------------\r\n       PAGE\r\n       ----------------------------------------- */\r\n\r\n    .page-area,\r\n    .page-area.full {\r\n        width: 100%;\r\n        margin-left: 0;\r\n    }\r\n\r\n    .main-content {\r\n        width: 100%;\r\n        min-height: 100vh;\r\n\r\n        padding: 75px 12px 25px 12px;\r\n\r\n        box-sizing: border-box;\r\n        overflow-x: hidden;\r\n    }\r\n\r\n    .main-content .container-fluid {\r\n        padding-left: 0 !important;\r\n        padding-right: 0 !important;\r\n    }\r\n\r\n    /* -----------------------------------------\r\n       DASHBOARD TITLE\r\n       ----------------------------------------- */\r\n\r\n    .dashboard-title {\r\n        font-size: 18px;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .dashboard-icon {\r\n        width: 24px;\r\n        height: 24px;\r\n    }\r\n\r\n\r\n    /* -----------------------------------------\r\n       SEARCH CARD\r\n       ----------------------------------------- */\r\n\r\n    .search-card {\r\n        width: 100%;\r\n\r\n        padding: 18px 15px;\r\n\r\n        border-radius: 20px;\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        align-items: stretch;\r\n        justify-content: flex-start;\r\n\r\n        gap: 15px;\r\n    }\r\n\r\n    .search-card h2 {\r\n        font-size: 20px;\r\n        text-align: left;\r\n\r\n        white-space: normal;\r\n        margin: 0;\r\n    }\r\n\r\n    .search-card > div {\r\n        width: 100%;\r\n        max-width: 100%;\r\n    }\r\n\r\n    .search-card .search-input {\r\n        width: 100%;\r\n        height: 44px;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n\r\n    /* -----------------------------------------\r\n       TABLE\r\n       ----------------------------------------- */\r\n\r\n    .table-responsive {\r\n        width: 100%;\r\n\r\n        overflow-x: auto;\r\n        overflow-y: hidden;\r\n\r\n        border-radius: 15px;\r\n\r\n        -webkit-overflow-scrolling: touch;\r\n    }\r\n\r\n    .table-responsive .project-table {\r\n        min-width: 900px;\r\n        width: 900px;\r\n    }\r\n\r\n    .project-table thead th {\r\n        padding: 12px;\r\n        font-size: 13px;\r\n    }\r\n\r\n    .project-table tbody td {\r\n        padding: 12px;\r\n        font-size: 13px;\r\n    }\r\n\r\n\r\n    /* -----------------------------------------\r\n       PAGINATION\r\n       ----------------------------------------- */\r\n\r\n    .pagination-section {\r\n        width: 100%;\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        gap: 12px;\r\n\r\n        margin-top: 18px;\r\n    }\r\n\r\n    .pagination-section p {\r\n        width: 100%;\r\n        text-align: center;\r\n        font-size: 13px;\r\n    }\r\n\r\n    .pagination-controls {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: 5px;\r\n    }\r\n\r\n    .pagination-controls button {\r\n        min-width: 40px;\r\n        height: 40px;\r\n\r\n        padding: 0 9px;\r\n\r\n        font-size: 17px;\r\n        border-radius: 8px;\r\n    }\r\n}\r\n\r\n\r\n/* =========================================================\r\n   SMALL MOBILE\r\n   ========================================================= */\r\n\r\n@media (max-width: 480px) {\r\n\r\n    .main-content {\r\n        padding: 70px 8px 20px 8px;\r\n    }\r\n\r\n    .dashboard-title {\r\n        font-size: 17px;\r\n    }\r\n\r\n    .search-card {\r\n        padding: 15px 12px;\r\n        border-radius: 18px;\r\n    }\r\n\r\n    .search-card h2 {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .search-card .search-input {\r\n        height: 42px;\r\n        font-size: 13px;\r\n    }\r\n\r\n    .table-responsive {\r\n        border-radius: 12px;\r\n    }\r\n\r\n    .pagination-controls {\r\n        gap: 4px;\r\n    }\r\n\r\n    .pagination-controls button {\r\n        min-width: 36px;\r\n        height: 38px;\r\n        padding: 0 7px;\r\n        font-size: 16px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
